export default (client) => {
  return {
    acceptTermsAndConditions(trackingData = null) {
      const config = {}

      if (trackingData) {
        config.params = { track: JSON.stringify(trackingData) }
      }

      return client.post(
        '/saas/user/accept-terms-and-conditions/',
        null,
        config
      )
    },
    addAdditionalInformation({
      country,
      team,
      companySize,
      companyName,
      role,
    }) {
      return client.post('/saas/user/add-additional-information/', {
        country,
        team,
        company_size: companySize,
        company_name: companyName,
        role,
      })
    },
  }
}
